// extracted by mini-css-extract-plugin
export var legendIndicator = "_9s-1";
export var legendRight = "_9s-0";